import { createInstance } from "@jonkoops/matomo-tracker-react";

const instance = createInstance({
  urlBase: process.env.REACT_APP_ANALYTICS_URL,
  siteId: process.env.REACT_APP_ANALYTICS_SITE_ID,
});

export default instance;
